new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        //fade: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    $('#carousel-comunicado').slick({
        arrows: true,
        dots: false,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        delay: 2000,
        speed: 700,

        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                }
            }
        ]
    })

    $('#faixa-comunicado').slick({
        arrows: false,
        dots: false,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        delay: 2000,
        speed: 700,

        responsive: [
            {
                breakpoint: 991,
                settings: 'unslick'
            }
        ]
    })

    $('#widget-category').slick({
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: false,
        speed: 700,

        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    dots: false,
                    slidesToShow: 5,
                    slidesToScroll: 1,
                }
            }
        ]
    })

    $('.product_list').slick({
        arrows: true,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,

        responsive: [
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    dots: false,
                    slidesToShow: 4,
                }
            }
        ]
    });

    $('.widget-catalog__photos').slick({
        arrows: false,
        dots: false,
        infinite: false,
        autoplay: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,

        responsive: [
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    dots: false,
                    slidesToShow: 5,
                }
            }
        ]
    });

    $('.product-ratings-list').slick({
        arrows: true,
        dots: true,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,

        responsive: [
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                }
            }
        ]
    });
})

function copyElementContentToClipboard(event) {
    var clipboardElement = event.currentTarget;
    var clipboardContent = clipboardElement.textContent || clipboardElement.innerText;
    
    navigator.clipboard.writeText(clipboardContent).then(function() {
        clipboardElement.classList.add("copied");
    }).catch(function(error) {
        console.error("Erro ao copiar para o clipboard:", error);
    });
}

// Adicionar o event listener ao elemento clipboard
document.getElementById("tc-coupon").addEventListener("click", copyElementContentToClipboard);